import {httpClientService} from '../settingsApi/httpClientService';

import {commonCheckoutClientWrapper} from './commonCheckoutClientWrapper';

export async function getCheckoutSessionStatusFromCommonCheckoutApi({updateStatusUrl}: {updateStatusUrl: string}) {
  const httpClient = httpClientService.getHttpClient({api: 'WALLET'});

  const statusResponse = await commonCheckoutClientWrapper<CheckoutSessionsResponse>({
    httpClient,
    request: {
      url: updateStatusUrl || '',
    },
  });
  const completeStatuses = ['COMPLETED', 'FAILED'];
  const {data: {checkoutSession: {checkoutSessionStatus: status = ''} = {}} = {}} = statusResponse;
  const currentStatus = (completeStatuses.includes(status || '') ? status : 'PENDING') as
    | 'COMPLETED'
    | 'FAILED'
    | 'PENDING';
  return {status: currentStatus, response: statusResponse.data};
}
